.customer-organization-form__billing-info__billing-info-inputs-container {
  width: 360px;
}
